import { useProviders } from "../../providers/useProviders";
import type { SelectChangeEvent } from "@mui/material/Select";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { providerColor } from "../../providers/providerColor";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { IconButton, InputAdornment } from "@mui/material";
import { Clear } from "@mui/icons-material";

export function ProviderMultiSelect({
  providerIds,
  onChange,
}: {
  readonly providerIds: string[];
  readonly onChange: (ids: string[]) => void;
}) {
  const { providers } = useProviders();
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    const values: string[] = typeof value === "string" ? value.split(",") : value;
    onChange(values);
  };
  const label = "Dostawcy";
  return (
    <FormControl>
      <InputLabel id="ProviderMultiSelect">{label}</InputLabel>
      <Select
        label={label}
        labelId="ProviderMultiSelect"
        fullWidth
        multiple
        value={providerIds}
        onChange={handleChange}
        renderValue={(selected) => `Wybrano: ${selected.length}`}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={() => onChange([])} style={{ marginRight: 16 }}>
              <Clear />
            </IconButton>
          </InputAdornment>
        }
      >
        {providers.map((provider) => (
          <MenuItem key={provider.id} value={provider.id} style={{ position: "relative" }}>
            <Checkbox checked={providerIds.includes(provider.id)} />
            <ListItemText primary={provider.name} />
            <div
              style={{
                position: "absolute",
                width: 24,
                height: 24,
                textAlign: "center",
                ...providerColor(provider),
                right: 4,
              }}
            >
              $
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
